import { Box, Chip, Container, Stack, Typography } from '@mui/material';
import { colors, heroStyles } from './eventDetailsStyles';

const EventHero = ({ eventDetails, hasAvailableSessions, registrationStatus }) => (
  <Box sx={heroStyles.shell}>
    <Container maxWidth="lg">
      <Stack direction="row" spacing={1} useFlexGap sx={{ ...heroStyles.chips, flexWrap: 'wrap' }}>
        <Chip label={eventDetails.category || 'Event'} sx={heroStyles.categoryChip} />
        <Chip
          label={registrationStatus}
          sx={{ bgcolor: hasAvailableSessions ? colors.successBg : '#fee2e2', color: hasAvailableSessions ? colors.successText : '#991b1b' }}
        />
      </Stack>
      <Typography variant="h3" sx={heroStyles.title}>{eventDetails.title}</Typography>
      <Typography variant="h6" sx={heroStyles.subtitle}>{eventDetails.hero_subtitle || eventDetails.summary || ''}</Typography>
    </Container>
  </Box>
);

export default EventHero;
